import React from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

/**
 * Generic "are you sure" step for a plan/subscription change.
 * Used both as the second step of DowngradeModal (confirm a downgrade
 * target) and standalone from Billing.js (confirm reactivating /
 * cancelling a scheduled change) — the caller owns all copy so the same
 * component can say "Confirm downgrade" or "Keep Growth".
 */
export default function ConfirmPlanChangeModal({
  open,
  title,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!open) return null;

  return (
    <Modal
      title={title}
      onClose={onCancel}
      maxWidth="max-w-md"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            <span>{cancelLabel}</span>
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={loading}>
            <span>{loading ? "Working…" : confirmLabel}</span>
          </Button>
        </>
      }
    >
      <div className="text-sm text-foreground">{children}</div>
    </Modal>
  );
}
